import React from 'react';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';
import { RelatedArticles } from './related-articles';
import { ArticleContent } from './article-content';
import SEO from '../seo';
import { useArticleContext } from './context';
import { sanitizeUrl } from '../../utils/sanitize-url';

const AnalyticEvents = ({ trackEvent, data }) => {
  trackEvent('page_hit', { page_hit: 'article', data });
};

const Article = () => {
  const { strapiArticle, isLoading } = useArticleContext() || {};
  const { trackEvent } = useAnalytics();
  if (!isLoading) AnalyticEvents({ trackEvent, data: strapiArticle });

  const {
    article_name,
    article_url,
    topic,
    article_seo_title_tag,
    article_seo_meta_description,
    article_seo_keywords
  } = strapiArticle || {};

  return (
    <>
      <SEO
        title={article_seo_title_tag || article_name}
        description={article_seo_meta_description}
        keywords={article_seo_keywords}
        url={`${sanitizeUrl(topic?.topic_url)}/${sanitizeUrl(article_url)}`}
      />

      <ArticleContent />

      <RelatedArticles />
    </>
  );
};

export default Article;
